module.exports = __webpack_public_path__ + "static/media/Dunes.f4361ae5.jpg";